import { c, IllustrationFrame, sc, type IllustrationProps } from './Illustration';

/** Owner list empty state. A wishlist page with ticks, a star, and a pencil. */
export function ListScroll(props: IllustrationProps) {
  return (
    <IllustrationFrame {...props}>
      <ellipse cx="80" cy="144" rx="44" ry="6" style={{ fill: sc('border.default') }} />
      <rect
        x="36"
        y="18"
        width="88"
        height="118"
        rx="12"
        style={{ fill: sc('bg.surface'), stroke: sc('border.strong'), strokeWidth: 3 }}
      />
      <circle cx="54" cy="46" r="7" style={{ fill: c('blue.100') }} />
      <path
        d="M50 46l3 3 6-7"
        style={{
          fill: 'none',
          stroke: c('blue.600'),
          strokeWidth: 3,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      />
      <rect x="67" y="42" width="42" height="8" rx="4" style={{ fill: sc('border.default') }} />
      <circle cx="54" cy="72" r="7" style={{ fill: c('berry.100') }} />
      <path
        d="M50 72l3 3 6-7"
        style={{
          fill: 'none',
          stroke: c('berry.600'),
          strokeWidth: 3,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      />
      <rect x="67" y="68" width="34" height="8" rx="4" style={{ fill: sc('border.default') }} />
      <path
        d="M54 91l2.6 5.3 5.8.8-4.2 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8-4.2-4.1 5.8-.8z"
        style={{ fill: c('gold.400') }}
      />
      <rect x="67" y="94" width="38" height="8" rx="4" style={{ fill: sc('border.default') }} />
      <g transform="rotate(35 122 110)">
        <rect x="114" y="74" width="16" height="56" rx="4" style={{ fill: c('gold.300') }} />
        <rect x="114" y="74" width="16" height="10" rx="3" style={{ fill: c('berry.400') }} />
        <path d="M114 130h16l-8 14z" style={{ fill: c('neutral.300') }} />
      </g>
    </IllustrationFrame>
  );
}
